module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "216",
      "src": "images/f0005-01.jpg",
      "width": "500"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("To")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Paul and Maureen Beebe")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Grandpa and Grandma Beebe")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Eba Jones, Fire Chief")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Wyle Maddox, Leader of Roundup Men")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("L. Quillen, Roundup Man")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Wilbur Wimbrow, Roundup Man")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Howard Rodgers, Roundup Man")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Harvey Beebe, Roundup Man")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Harold Beebe, father of Paul and Maureen")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Ralph Beebe, uncle of Paul and Maureen")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Delbert Daisey, Bronc Buster")]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_vm._v("Victoria and William Pruitt")]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_vm._v("all of whom really live on Chincoteague Island and who appear as characters in this book")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("and a special dedication to Three Chincoteague Ponies")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Phantom"), _c('br'), _vm._v("Pied Piper"), _c('br'), _vm._v("Misty")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 63
// module chunks = 0